/**
 * How long a recording actually is, read from the file before it is uploaded.
 *
 * songs.duration_seconds is read all over the app — every <Player>, the
 * collective rows, Learn — and until this existed nothing ever wrote it, so it
 * was null on every row and every caller silently fell back to zero.
 *
 * The browser already decodes the header to render a player, so this costs one
 * metadata load and no network. It never rejects: a duration we could not read
 * is null, which is exactly what the column held before, so a failure here can
 * only leave things as they already were.
 */
export function readDuration(file) {
  return new Promise((resolve) => {
    const isVideo = (file.type || '').startsWith('video/')
      || /\.(mov|mp4|m4v|webm|mkv|avi|3gp|mpe?g)$/i.test(file.name || '')
    const el = document.createElement(isVideo ? 'video' : 'audio')
    const url = URL.createObjectURL(file)

    // Some containers report Infinity until they have been seeked. Give up
    // rather than chase it — a missing duration is not worth blocking on.
    const done = (v) => {
      clearTimeout(timer)
      URL.revokeObjectURL(url)
      el.removeAttribute('src')
      resolve(Number.isFinite(v) && v > 0 ? Math.round(v) : null)
    }
    const timer = setTimeout(() => done(null), 5000)

    el.preload = 'metadata'
    el.muted = true
    el.addEventListener('loadedmetadata', () => done(el.duration), { once: true })
    el.addEventListener('error', () => done(null), { once: true })
    el.src = url
  })
}
